import { render, staticRenderFns } from "./DriverPropDetail.vue?vue&type=template&id=2cc0d0ec&scoped=true"
import script from "./DriverPropDetail.vue?vue&type=script&lang=js"
export * from "./DriverPropDetail.vue?vue&type=script&lang=js"
import style0 from "./DriverPropDetail.vue?vue&type=style&index=0&id=2cc0d0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0d0ec",
  null
  
)

export default component.exports